import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { DashboardUtils } from "../../../dashboard_utils";
import { trpc } from "../../../utils/trpc";
import { setDocTitle } from "../../../web_ui";
import { BackButton } from "../base_components/back_button";
import { DashboardContainer } from "../base_components/dashboard_container";
import { PremiumActivePurchaseListings } from "./premium_active_purchase_listings";
import { PricingTable } from "./pricing_table";
import { RestoreDiscordPurchasesButton } from "./restore_discord_purchases_button";
import { GifFeatureSections } from "../../../../ssr/premium/components/gif-feature-sections";
import { FeatureComparisonTable } from "../../../../ssr/premium/components/feature-comparison-table";
import { CustomBotCard } from "../../../../ssr/premium/components/custom-bot-card";
import { SimpleContactModal } from "../../../../ssr/premium/components/simple-contact-modal";

export function PremiumPage(props: { back_link?: string }) {
	useEffect(() => {
		setDocTitle("Premium");
	}, []);

	const [showContactModal, setShowContactModal] = useState(false);
	const history = useHistory();

	const prices_query = trpc.premium.getAllProductsPrices.useQuery();
	const premium_details_query = trpc.premium.getUserPremiumDetails.useQuery();

	if (!prices_query.isSuccess || !premium_details_query.isSuccess) {
		return <DashboardUtils.RenderFullLoadingThrobberPage />;
	}

	return (
		<>
			<DashboardContainer
				title="Premium"
				size="lg"
				bread_crumbs={
					<BackButton
						label="Back"
						onClick={() => {
							history.push(props.back_link ?? "/dashboard/");
						}}
					/>
				}
			>
				<div className="flex flex-col gap-8">
					<PremiumActivePurchaseListings
						premium_details_query={premium_details_query}
					/>
					<PricingTable
						link_type="Link"
						current_pricing={prices_query.data}
						has_used_free_trial={
							premium_details_query.data
								.has_used_stripe_free_trial
						}
					/>
					<div className="ml-auto">
						<RestoreDiscordPurchasesButton />
					</div>

					{/* Visual feature showcase */}
					<GifFeatureSections />

					{/* Feature comparison table */}
					<FeatureComparisonTable />

					{/* Custom bot card at bottom */}
					<div className="mt-16">
						<CustomBotCard
							onContactClick={() => setShowContactModal(true)}
						/>
					</div>
				</div>
			</DashboardContainer>

			{/* Contact modal */}
			{showContactModal && (
				<SimpleContactModal
					onClose={() => setShowContactModal(false)}
				/>
			)}
		</>
	);
}
